﻿import {DateTime, isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {IMvvmContextState} from "@2d-front-monorepo/design-library";
import {
	AttachmentResult,
	CreateAttachmentComponent,
	ICreateComponentAttachments
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {formatDateTimeShort} from "../functions";

export default function UpdateAttachmentComponent({context, attachment}: {
	context: IMvvmContextState<ICreateComponentAttachments>,
	attachment: AttachmentResult
}): JSX.Element {
	const showReason = !isNullOrEmpty(attachment.statusReason);
	const showExpires = attachment.expires != null && attachment.expires <= DateTime.utcNow();
	const showInformation = !isNullOrEmpty(attachment.additionalInformation);

	return <div className="entity-documentation-entry__update">
		<div>
			{showReason &&
                <span className="entity-documentation-entry__reason">
					<strong>{translation(PermitTranslations.documentation__reason)}</strong>
                    &nbsp;
					{attachment.statusReason}
				</span>
			}

			{showExpires &&
                <span className="entity-documentation-entry__expires">
					<strong>{translation(PermitTranslations.documentation__expires)}</strong>
                    &nbsp;
					{formatDateTimeShort(attachment.expires!)}
				</span>
			}

			{showInformation &&
                <span className="entity-documentation-entry__comments">
					<strong>{translation(PermitTranslations.documentation__comments)}</strong>
                    &nbsp;
					{attachment.additionalInformation}
				</span>
			}
		</div>
		<CreateAttachmentComponent context={context} type={attachment.type} required={true}/>
	</div>
}
